import { formatDataToBeeConfigs } from "containers/admin/clients/client/theme-page/preview/helpers/bee-data-formatter/bee-data-formatter";
import {
  formValuesToThemeSections,
  themeToFormValues,
} from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.helpers";

import type { SavedTheme } from "hooks/api/use-theme";

import THEME_DEFAULT_DATA from "containers/admin/clients/client/theme-page/theme-default-data.json";

/**
 * The configs BEE reads, built from the saved theme the way the legacy Publish builds them. The email
 * sections go through the form's round trip so a section the theme lacks gets its default rather than
 * crashing the formatter, which expects every section.
 */
export const themeToBeeConfigs = (theme: SavedTheme | undefined) =>
  formatDataToBeeConfigs({
    colors: { ...THEME_DEFAULT_DATA.colors, ...theme?.colors },
    fonts: { googleFonts: [], adobeFontsProjectId: "", ...theme?.fonts },
    ...formValuesToThemeSections(themeToFormValues(theme)),
  });
